import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { createElement } from 'react';
import { ksdpExceptionsReadPermission } from '@internal/ksdp-permissions-common';
import { guardKsdpPage } from '@internal/ksdp-permissions-react';
import { ExceptionsPage } from './components/ExceptionsPage';
import { CustomExceptionsIcon } from './icons/ExceptionsIcon';

const exceptionsPage = PageBlueprint.make({
  name: 'exceptions',
  params: {
    path: '/exceptions',
    title: 'Exceptions',
    icon: createElement(CustomExceptionsIcon),
    loader: async () =>
      guardKsdpPage(
        ksdpExceptionsReadPermission,
        createElement(ExceptionsPage),
      ),
  },
});

export const exceptionsPlugin = createFrontendPlugin({
  pluginId: 'exceptions',
  extensions: [exceptionsPage],
});
